// extracted by mini-css-extract-plugin
export var attribution = "_bd-4";
export var authorName = "_bd-5";
export var quote = "_bd-3";
export var testimonial = "_bd-2";
export var trustedBy = "_bd-0";
export var trustedByLabel = "_bd-1";